export default __webpack_public_path__ + "static/media/home.04fbeef4.png";